var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import toFormat from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import isValid from 'date-fns/isValid';
import dateParse from 'date-fns/parse';
import * as React from 'react';
import { DATE_FORMAT_FOR_DB, DATE_FORMAT_FOR_FNS } from '../../constants/constants';
import { getDateFnsLocaleDateFormat } from '../../util-components/datetime';
import Calendar from '../calendar';
import Input from '../input';
import { Styled } from './style';
var TODAY = new Date();
var displayDate = function (value, format) {
    if (value && value !== '') {
        var date = dateParse(value, DATE_FORMAT_FOR_DB, new Date());
        return toFormat(date, format);
    }
    return '';
};
var getEndOfDay = function (date) {
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var day = date.getDate();
    return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
};
var getCalendarDateValue = function (date) { return date ? dateParse(date, DATE_FORMAT_FOR_DB, new Date()) : undefined; };
var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperRef = React.createRef();
        _this.calendarRef = React.createRef();
        _this.startInputRef = React.createRef();
        _this.endInputRef = React.createRef();
        _this.pageClick = function (event) {
            if (_this.wrapperRef.current &&
                _this.calendarRef.current &&
                (!_this.wrapperRef.current.contains(event.target) && !_this.calendarRef.current.contains(event.target))) {
                _this.setState({
                    isStartPopoverOpen: false,
                    isEndPopoverOpen: false,
                });
            }
        };
        _this.handleStartInputOnFocus = function () {
            _this.setState({ isStartPopoverOpen: true, isEndPopoverOpen: false });
        };
        _this.handleEndInputOnFocus = function () {
            _this.setState({ isStartPopoverOpen: false, isEndPopoverOpen: true });
        };
        _this.updateStartDate = function (startDateText) { return __awaiter(_this, void 0, void 0, function () {
            var _a, onChange, value, isDateValid, startDate, isDateAfter;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, onChange = _a.onChange, value = _a.value;
                        isDateValid = isValid(new Date(startDateText));
                        if (!(isDateValid && this.endInputRef.current.inputRef.current)) return [3 /*break*/, 2];
                        startDate = dateParse(startDateText, DATE_FORMAT_FOR_FNS, new Date());
                        if (!value.end && value.end !== undefined) {
                            isDateAfter = isValid(new Date(value.end)) && isAfter(startDate, new Date(value.end));
                            if (!isDateAfter) {
                                this.endInputRef.current.inputRef.current.focus();
                                if (onChange) {
                                    onChange(__assign(__assign({}, value), { start: toFormat(startDate, DATE_FORMAT_FOR_DB) }));
                                }
                            }
                        }
                        else {
                            this.endInputRef.current.inputRef.current.focus();
                            if (onChange) {
                                onChange(__assign(__assign({}, value), { start: toFormat(startDate, DATE_FORMAT_FOR_DB) }));
                            }
                        }
                        return [4 /*yield*/, this.setState({
                                isStartPopoverOpen: false,
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.updateEndDate = function (endDateText) { return __awaiter(_this, void 0, void 0, function () {
            var _a, onChange, value, isDateValid, endDate, startDate, isDateBefore;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, onChange = _a.onChange, value = _a.value;
                        isDateValid = isValid(new Date(endDateText));
                        if (!isDateValid) return [3 /*break*/, 2];
                        endDate = dateParse(endDateText, DATE_FORMAT_FOR_FNS, new Date());
                        if (value.start && value.start !== '') {
                            startDate = dateParse(value.start, DATE_FORMAT_FOR_DB, new Date());
                            isDateBefore = isValid(startDate) && isBefore(endDate, startDate);
                            if (!isDateBefore) {
                                if (onChange) {
                                    onChange(__assign(__assign({}, value), { end: toFormat(endDate, DATE_FORMAT_FOR_DB) }));
                                }
                            }
                        }
                        else if (onChange) {
                            onChange(__assign(__assign({}, value), { end: toFormat(endDate, DATE_FORMAT_FOR_DB) }));
                        }
                        return [4 /*yield*/, this.setState({
                                isEndPopoverOpen: false,
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.handleStartCalendarChange = function (startDate) {
            _this.updateStartDate(toFormat(startDate, DATE_FORMAT_FOR_FNS));
        };
        _this.handleEndCalendarChange = function (endDate) {
            _this.updateEndDate(toFormat(endDate, DATE_FORMAT_FOR_FNS));
        };
        _this.getMinStartDate = function () {
            var _a = _this.props, start = _a.value.start, disablePastDateSelection = _a.disablePastDateSelection;
            if (!disablePastDateSelection) {
                return undefined;
            }
            var startDate = getCalendarDateValue(start);
            // We allow startDates in the past, if it was already set before
            var minStartDate = !startDate ? TODAY :
                (startDate < TODAY) ? startDate : TODAY;
            return minStartDate;
        };
        _this.state = {
            isStartPopoverOpen: false,
            isEndPopoverOpen: false,
            value: _this.props.value,
            startDateText: displayDate(_this.props.value.start, getDateFnsLocaleDateFormat(props.locale)),
            endDateText: displayDate(_this.props.value.end, getDateFnsLocaleDateFormat(props.locale)),
        };
        return _this;
    }
    DateRangePicker.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.value.start !== prevState.value.start || nextProps.value.end !== prevState.value.end) {
            return {
                start: nextProps.value.start,
                end: nextProps.value.end,
                startDateText: displayDate(nextProps.value.start, getDateFnsLocaleDateFormat(nextProps.locale)),
                endDateText: displayDate(nextProps.value.end, getDateFnsLocaleDateFormat(nextProps.locale)),
            };
        }
        return null;
    };
    DateRangePicker.prototype.componentDidMount = function () {
        if (this.props.defaultFocusValue && this.props.value.start === '' && this.startInputRef.current) {
            this.startInputRef.current.inputRef.current.focus();
        }
        window.addEventListener('mousedown', this.pageClick, false);
    };
    DateRangePicker.prototype.componentWillUnmount = function () {
        window.removeEventListener('mousedown', this.pageClick, false);
    };
    DateRangePicker.prototype.render = function () {
        return (React.createElement(Styled, { className: this.props.className, inverted: this.props.inverted, style: this.props.style, flipWay: this.props.flipWay },
            React.createElement("div", { className: this.props.value.start !== '' ? 'date-range' : 'date-range placeholder', ref: this.wrapperRef },
                React.createElement("div", { className: "date-wrapper" },
                    React.createElement("div", { className: "input-container" },
                        React.createElement(Input, { className: "input-start-date", ref: this.startInputRef, value: this.state.startDateText, onFocus: this.handleStartInputOnFocus, placeholder: this.props.startPlaceholder, disabled: this.props.disabled })),
                    React.createElement("div", { className: "calendar-container", style: { display: this.state.isStartPopoverOpen ? 'block' : 'none' }, ref: this.calendarRef },
                        React.createElement(Calendar, { callback: this.handleStartCalendarChange, value: getCalendarDateValue(this.props.value.start), locale: this.props.locale, maxDate: this.props.value.end && this.props.value.end !== '' ? getEndOfDay(new Date(this.props.value.end)) : undefined, minDate: this.getMinStartDate() }))),
                React.createElement("div", { className: "path" }, "-"),
                React.createElement("div", { className: "date-wrapper" },
                    React.createElement("div", { className: "input-container" },
                        React.createElement(Input, { className: "input-end-date", ref: this.endInputRef, value: this.state.endDateText, onFocus: this.handleEndInputOnFocus, placeholder: this.props.endPlaceholder, disabled: this.props.disabled })),
                    React.createElement("div", { className: "calendar-container", style: { display: this.state.isEndPopoverOpen ? 'block' : 'none' }, ref: this.calendarRef },
                        React.createElement(Calendar, { callback: this.handleEndCalendarChange, activeStartDate: this.props.value.start !== '' ? getCalendarDateValue(this.props.value.start) : new Date(), value: getCalendarDateValue(this.props.value.end), locale: this.props.locale, minDate: this.props.value.start !== '' ? getCalendarDateValue(this.props.value.start) : TODAY }))))));
    };
    return DateRangePicker;
}(React.Component));
export default DateRangePicker;
//# sourceMappingURL=index.js.map